import React, { Component } from 'react';
// import PropTypes from 'prop-types';

export default class UnityNotification extends Component {
  constructor(props) {
    super(props);
    this.notificationRef = React.createRef();
  }

  componentDidMount() {
    this.updateProperties();
  }

  componentDidUpdate() {
    this.updateProperties();
  }

  updateProperties() {
    const { props, notificationRef } = this;
    const unityNotification = notificationRef.current;
    const { onClose } = props;
    if (!!unityNotification) {
      if (!!onClose) unityNotification.onClose = onClose;
    }
  }

  render() {
    const { notificationRef, props } = this;
    return (
      <unity-notification
        ref={notificationRef}
        {...props}
      >
      </unity-notification>
    );
  }
}

// export const NotificationPropsI = {
//   text: PropTypes.string,
//   subtext: PropTypes.string,
//   icon: PropTypes.string,
//   onClose: PropTypes.func,
//   style: PropTypes.object,
// };
//
// export const NotificationStylesI = {
//   '--notification-color': PropTypes.string,
//   '--notification-height': PropTypes.string,
//   '--notification-width': PropTypes.string,
//   '--notification-button-padding': PropTypes.string,
//   '--notification-z-index': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// };